import { createPortal } from "react-dom";


interface Props {
    open: boolean;
    children: React.ReactNode;
    anchorRef: React.RefObject<HTMLElement | null>;
}

export default function Anchor({ open, children, anchorRef }: Props) {
    if (!open) return null;
    if (!anchorRef.current) return null;
    const rect = anchorRef.current?.getBoundingClientRect();
    return createPortal(
        <div style={{
            position: "absolute",
            top: rect?.bottom ?? 0,
            left: rect?.left ?? 0,
            zIndex: 9999
        }}>
            {children}
        </div>,
        document.body
    );
}